import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getOrderList({
    courier_id = '',
    cursor,
    end_date = '',
    limit,
    q,
    sort_by = '',
    start_date = '',
    status = '',
  }) {
    const params = {
      courier_id,
      cursor,
      end_date,
      limit,
      q,
      sort_by,
      start_date,
      status,
    };
    const url = '/shipments';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  confirmShipment(id, trackCode) {
    return api.post(`/shipments/${id}/confirm_shipment`, {
      tracking_code: trackCode,
    });
  },
  updateShipment(id, trackCode) {
    return api.post(`/shipments/${id}/update_shipment`, {
      tracking_code: trackCode,
    });
  },
  confirmDelivery(id) {
    return api.post(`/shipments/${id}/confirm_delivery`);
  },
  getOrderDetail(id) {
    return api.get(`/shipments/${id}`);
  },
  getOrderActivity(id) {
    return api.get(`/shipments/${id}/activities`);
  },
  getOrderTracking(id) {
    return api.get(`/shipments/${id}/track_shipment`);
  },
  getOrderShippingLabel(id) {
    return api.get(`/shipments/${id}/shipping_label`);
  },
  getCourierList() {
    return api.get(`/shipments/couriers?status=active&`);
  },
  findDriverGosend(id) {
    return api.post(`/shipments/${id}/delivery_order`);
  },
  shipOrder(id) {
    return api.post(`/shipments/${id}/ship_order`);
  },
};
